import  Url  from "../address";

const addressVerification = Url + "/user/verification";

export default { addressVerification };
